import Vue from 'vue'
import Router from 'vue-router'

import Preferences from './views/Preferences.vue'
import Tokens from './views/Tokens.vue'
import About from './views/About.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/preferences',
			name: 'preferences',
			component: Preferences
		},
		{
			path: '/tokens/:token_ids?',
			name: 'tokens',
			component: Tokens
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
// 			component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
			component: About
		},
		{
			path: '/',
			redirect: '/about/'
		}
	]
})
